import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=91b125d6&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=91b125d6&lang=scss&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=91b125d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b125d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangxinfan/Documents/work/hqxkj/project/WSXS2025004F_平台运营服务养殖证示范化管理系统分包-水产三期/01code/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b125d6')) {
      api.createRecord('91b125d6', component.options)
    } else {
      api.reload('91b125d6', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=91b125d6&scoped=true&", function () {
      api.rerender('91b125d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback.vue"
export default component.exports